var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 9.66602H1.33301V13.9993H14.6663V9.66602Z",
    stroke: "#07A25C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 12.6667C12.2936 12.6667 12.6667 12.2936 12.6667 11.8333C12.6667 11.3731 12.2936 11 11.8333 11C11.3731 11 11 11.3731 11 11.8333C11 12.2936 11.3731 12.6667 11.8333 12.6667Z",
    fill: "#07A25C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 9.66628L3.01246 1.66602H13.0065L14.6663 9.66628",
    stroke: "#07A25C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 11.834H8.99967",
    stroke: "#07A25C",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteOnline);
export default __webpack_public_path__ + "static/media/site_online.b028f702da0ca4c105d873b32beda9be.svg";
export { ForwardRef as ReactComponent };